class FormToggle {
  forms: NodeListOf<HTMLFormElement>;

  constructor() {
    this.forms = document.querySelectorAll<HTMLFormElement>('.frame-type-form_formframework form');

    if (!this.forms.length) {
      return;
    }

    this.init();
  }

  init() {
    this.forms.forEach(form => {
      const targets = Array.from(form.querySelectorAll<HTMLElement>('.form-toggle-target'));

      if (!targets.length) {
        return;
      }

      const updateTargets = () => {
        const activeValues = new Set<string>();

        form.querySelectorAll<HTMLInputElement>('input[type="radio"]:checked').forEach(input => {
          activeValues.add(input.value);
        });
        
        form.querySelectorAll<HTMLInputElement>('input[type="checkbox"]:checked').forEach(input => {
          activeValues.add(input.value);
        });


        form.querySelectorAll<HTMLSelectElement>('select').forEach(select => {
          activeValues.add(select.value);
        });

        targets.forEach(target => {
          const targetValueClass = Array.from(target.classList).find(className => className.startsWith('form-toggle-target--'));
          const targetValue = targetValueClass?.replace('form-toggle-target--', '') ?? '';
          const isVisible = targetValue !== '' && activeValues.has(targetValue);

          target.classList.toggle('is-hidden', !isVisible);

          target.querySelectorAll<HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement>('input, select, textarea').forEach(input => {
            input.disabled = !isVisible;
            input.required = isVisible;
          });
        });
      };

      form.addEventListener('change', updateTargets);
      updateTargets();
    });
  }
}

const initIdealiveFormToggle = () => {
  const existingSubscriberForm = document.getElementById('idealive-381324');
  const euroAboForm = document.getElementById('idealive-eineuroabo-381468');
  const existingSubscriberNo = document.querySelector<HTMLInputElement>('#idealive-381324-radiobutton-1 input[value="Nein"]');
  const euroAboYes = document.querySelector<HTMLInputElement>('#idealive-eineuroabo-381468-radiobutton-1 input[value="Ja"]');

  if (!(existingSubscriberForm instanceof HTMLFormElement) || !(euroAboForm instanceof HTMLFormElement) || !existingSubscriberNo || !euroAboYes) {
    return;
  }

  const setFormVisibility = (form: HTMLFormElement, isVisible: boolean) => {
    form.classList.toggle('is-hidden', !isVisible);
    form.querySelectorAll<HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement>('input, select, textarea').forEach(input => {
      input.disabled = !isVisible;
    });
  };

  const updateForms = () => {
    const showEuroAbo = existingSubscriberNo.checked;
    const showExistingSubscriber = euroAboYes.checked;

    setFormVisibility(existingSubscriberForm, !showEuroAbo || showExistingSubscriber);
    setFormVisibility(euroAboForm, showEuroAbo && !showExistingSubscriber);
  };

  existingSubscriberNo.addEventListener('change', updateForms);
  euroAboYes.addEventListener('change', updateForms);
  setFormVisibility(euroAboForm, false);
};

initIdealiveFormToggle();
new FormToggle();